export default {
    'name': 'pledge',
    'label': 'legal.tabs.Pledge',
    'getComponent': () => import('./pledge.vue'),
    'tabIndex': 3,
    'left': false,
    'right': false,
    'singleView': true,
    'exclusiveRoutePath': '/legal/pledge',
};
